import React, { useState } from 'react';
import { saveProfile } from '../services/profileService';

function ProfileSetup({ user, onComplete }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await saveProfile(user.uid, {
        name: name.trim(),
        email: email.trim() || '',
        phone: user.phoneNumber || '',
        addresses: [],
        createdAt: new Date().toISOString(),
      });
      // Don't call onComplete - let Firebase listener detect the update
    } catch (err) {
      setError('Failed to save profile. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="profile-setup-overlay">
      <div className="profile-setup-container">
        <div className="profile-setup-header">
          <h2>Complete Your Profile</h2>
          <p className="muted">Help us personalize your experience</p>
        </div>

        <form onSubmit={handleSubmit} className="profile-setup-form">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email (Optional)</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              value={user.phoneNumber || ''}
              disabled
              style={{ background: '#f3f4f6', cursor: 'not-allowed' }}
            />
          </div>

          {error && <p className="error">{error}</p>}

          <button
            type="submit"
            className="btn primary full-width"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ProfileSetup;
